module.exports = __webpack_public_path__ + "static/media/Google__G__Logo.686f8efa.svg";